// // import React, { useState } from 'react';
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   Box,
// //   Typography,
// //   IconButton,
// //   Stack,
// // } from '@mui/material';
// // import EditIcon from '@mui/icons-material/Edit';
// // import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// // import DocsEditModal from './staffDocsEpmsModal';

// // const ExcessManageModal = ({ open, onClose, excessId, refId }) => {
// //   const [docsModalOpen, setDocsModalOpen] = useState(false);

// //   const handleClose = (event, reason) => {
// //     if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
// //     onClose();
// //   };

// //   const handleOpenDocsEdit = () => setDocsModalOpen(true);
// //   const handleDocsEditClose = () => setDocsModalOpen(false);

// //   const copyToClipboard = (text) => {
// //     navigator.clipboard.writeText(text);
// //   };

// //   return (
// //     <>
// //       <Dialog
// //         open={open}
// //         onClose={handleClose}
// //         maxWidth="md"
// //         fullWidth
// //         disableEscapeKeyDown
// //         PaperProps={{
// //           sx: {
// //             minHeight: '420px',
// //             borderRadius: 3,
// //             background: 'linear-gradient(135deg, #f8fafc, #eef2ff)',
// //           },
// //         }}
// //       >
// //         <DialogTitle sx={{ fontWeight: 600 }}>
// //           Manage Excess Record
// //         </DialogTitle>

// //         <DialogContent>
// //           <Box p={2}>
// //             {/* 🔥 Modern ID Cards */}
// //             <Stack direction="row" spacing={2} flexWrap="wrap">
              
// //               {/* Excess ID Card */}
// //               <Box
// //                 sx={{
// //                   flex: 1,
// //                   minWidth: 220,
// //                   p: 2,
// //                   borderRadius: 3,
// //                   background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
// //                   color: '#fff',
// //                   boxShadow: '0 10px 25px rgba(99,102,241,0.3)',
// //                   position: 'relative',
// //                   overflow: 'hidden',
// //                 }}
// //               >
// //                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
// //                   Excess ID
// //                 </Typography>

// //                 <Typography variant="h6" fontWeight="bold">
// //                   {excessId}
// //                 </Typography>

// //                 <IconButton
// //                   size="small"
// //                   onClick={() => copyToClipboard(excessId)}
// //                   sx={{
// //                     position: 'absolute',
// //                     top: 8,
// //                     right: 8,
// //                     color: '#fff',
// //                   }}
// //                 >
// //                   <ContentCopyIcon fontSize="small" />
// //                 </IconButton>
// //               </Box>

// //               {/* Reference ID Card */}
// //               <Box
// //                 sx={{
// //                   flex: 1,
// //                   minWidth: 220,
// //                   p: 2,
// //                   borderRadius: 3,
// //                   background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
// //                   color: '#fff',
// //                   boxShadow: '0 10px 25px rgba(59,130,246,0.3)',
// //                   position: 'relative',
// //                 }}
// //               >
// //                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
// //                   Reference ID
// //                 </Typography>

// //                 <Typography variant="h6" fontWeight="bold">
// //                   {refId}
// //                 </Typography>

// //                 <IconButton
// //                   size="small"
// //                   onClick={() => copyToClipboard(refId)}
// //                   sx={{
// //                     position: 'absolute',
// //                     top: 8,
// //                     right: 8,
// //                     color: '#fff',
// //                   }}
// //                 >
// //                   <ContentCopyIcon fontSize="small" />
// //                 </IconButton>
// //               </Box>

// //             </Stack>

// //             {/* Info text */}
// //             <Typography
// //               mt={3}
// //               color="text.secondary"
// //               sx={{ fontSize: '0.95rem' }}
// //             >
// //               Manage documents for this excess payment record.
// //             </Typography>

// //             {/* Manage Documents */}
// //             <Box
// //               mt={3}
// //               p={2}
// //               borderRadius={2}
// //               sx={{
// //                 background: '#fff',
// //                 boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'center',
// //               }}
// //             >
// //               <Typography fontWeight={500}>
// //                 Manage Documents
// //               </Typography>

// //               <IconButton
// //                 color="primary"
// //                 onClick={handleOpenDocsEdit}
// //               >
// //                 <EditIcon />
// //               </IconButton>
// //             </Box>
// //           </Box>
// //         </DialogContent>

// //         <DialogActions sx={{ px: 3, pb: 2 }}>
// //           <Button
// //             onClick={onClose}
// //             variant="contained"
// //             sx={{
// //               borderRadius: 2,
// //               textTransform: 'none',
// //               px: 3,
// //             }}
// //           >
// //             Close
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <DocsEditModal
// //         open={docsModalOpen}
// //         onClose={handleDocsEditClose}
// //         excessId={excessId}
// //         refId={refId}
// //       />
// //     </>
// //   );
// // };

// // export default ExcessManageModal;


// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   Stack,
// } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// import DocsEditModal from './staffDocsEpmsModal';
// import InstallmentEditModal from './staffInstallmentEditModal';

// const ExcessManageModal = ({ open, onClose, excessId, refId, excessAmt }) => {
//   const [docsModalOpen, setDocsModalOpen] = useState(false);
//   const [installmentModalOpen, setInstallmentModalOpen] = useState(false);

//   const handleClose = (event, reason) => {
//     if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
//     onClose();
//   };

//   const handleOpenDocsEdit = () => setDocsModalOpen(true);
//   const handleDocsEditClose = () => setDocsModalOpen(false);

//   const handleOpenInstallments = () => setInstallmentModalOpen(true);
//   const handleCloseInstallments = () => setInstallmentModalOpen(false);

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//         PaperProps={{
//           sx: {
//             minHeight: '450px',
//             borderRadius: 3,
//             background: 'linear-gradient(135deg, #f8fafc, #eef2ff)',
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600 }}>
//           Manage Excess Record
//         </DialogTitle>

//         <DialogContent>
//           <Box p={2}>
//             {/* ID Cards */}
//             <Stack direction="row" spacing={2} flexWrap="wrap">
//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 220,
//                   p: 2,
//                   borderRadius: 3,
//                   background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
//                   color: '#fff',
//                   boxShadow: '0 10px 25px rgba(99,102,241,0.3)',
//                   position: 'relative',
//                 }}
//               >
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Excess ID
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                   {excessId}
//                 </Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() => copyToClipboard(excessId)}
//                   sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Box>

//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 220,
//                   p: 2,
//                   borderRadius: 3,
//                   background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
//                   color: '#fff',
//                   boxShadow: '0 10px 25px rgba(59,130,246,0.3)',
//                   position: 'relative',
//                 }}
//               >
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Reference ID
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                   {refId}
//                 </Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() => copyToClipboard(refId)}
//                   sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Stack>

//             {/* Info Text */}
//             <Typography mt={3} color="text.secondary" sx={{ fontSize: '0.95rem' }}>
//               Manage documents and installments for this excess payment record.
//             </Typography>

//             {/* Manage Documents */}
//             <Box
//               mt={3}
//               p={2}
//               borderRadius={2}
//               sx={{
//                 background: '#fff',
//                 boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//               }}
//             >
//               <Typography fontWeight={500}>Manage Documents</Typography>
//               <IconButton color="primary" onClick={handleOpenDocsEdit}>
//                 <EditIcon />
//               </IconButton>
//             </Box>

//             {/* Manage Installments */}
//             <Box
//               mt={2}
//               p={2}
//               borderRadius={2}
//               sx={{
//                 background: '#fff',
//                 boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//               }}
//             >
//               <Typography fontWeight={500}>Manage Installments</Typography>
//               <IconButton color="primary" onClick={handleOpenInstallments}>
//                 <EditIcon />
//               </IconButton>
//             </Box>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button
//             onClick={onClose}
//             variant="contained"
//             sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Nested Modals */}
//       <DocsEditModal
//         open={docsModalOpen}
//         onClose={handleDocsEditClose}
//         excessId={excessId}
//         refId={refId}
//         excessAmt={excessAmt}
//       />

//       <InstallmentEditModal
//         open={installmentModalOpen}
//         onClose={handleCloseInstallments}
//         excessId={excessId}
//       />
//     </>
//   );
// };

// export default ExcessManageModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   TextField,
//   Link,
//   Divider,
//   IconButton,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { DELIVERY_STATUS_OPTIONS } from './workflowApi';

// const MAX_DOC_FILE_SIZE = 5 * 1024 * 1024; // 5 MB, matches backend limit

// // file input name -> (boolean field, link field, human label)
// const DOC_FILE_MAP = {
//   address_proof_file: {
//     boolField: 'is_address_proof_submited',
//     linkField: 'address_proof_link',
//     label: 'Address Proof',
//   },
//   pan_card_file: {
//     boolField: 'is_pan_card_submited',
//     linkField: 'pan_card_link',
//     label: 'PAN Card',
//   },
//   aadhar_card_file: {
//     boolField: 'is_aadhar_card_submited',
//     linkField: 'aadhar_card_link',
//     label: 'Aadhar Card',
//   },
//   affidavit_file: {
//     boolField: 'is_affidavit_submited',
//     linkField: 'affidavit_link',
//     label: 'Affidavit',
//   },
//   bank_statement_file: {
//     boolField: 'is_bank_statement_submited',
//     linkField: 'bank_statement_link',
//     label: 'Bank Statement',
//   },
// };

// const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
//   const [loading, setLoading] = useState(false);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   // PAYMENT STATE
//   const [paymentData, setPaymentData] = useState({
//     is_agreed_to_pay: false,
//     is_not_agreed_to_pay: false,
//     agreed_amount: '',
//     no_of_installment: 0,
//     agree_remarks: '',
//   });

//   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
//   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

//   // DOCS — checkboxes + link fields returned from the server
//   const [formData, setFormData] = useState({
//     is_address_proof_submited: false,
//     address_proof_link: '',
//     is_pan_card_submited: false,
//     pan_card_link: '',
//     is_aadhar_card_submited: false,
//     aadhar_card_link: '',
//     is_affidavit_submited: false,
//     affidavit_link: '',
//     is_bank_statement_submited: false,
//     bank_statement_link: '',
//     current_address: '',
//     updated_mobile_number: '',
//   });

//   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
//   const [docFiles, setDocFiles] = useState({});

//   // ORDER
//   const [orderStatus, setOrderStatus] = useState({
//     is_freezing_order_delivered: 'waiting',
//     is_freezing_order_issued: false,
//     is_bank_freezed: false,
//     is_summons_delivered: 'waiting',
//     is_summons_issued: false,
//     is_partial_un_freezing_order_submited: false,
//     is_partial_un_freezed: false,
//     is_defreezing_order_submited: false,
//     is_bank_defreezed: false,
//   });

//   // Fetch all data
//   const fetchAllData = async () => {
//     if (!excessId) return;

//     try {
//       setLoading(true);

//       const [docsRes, orderRes, paymentRes] = await Promise.all([
//         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
//       ]);

//       setFormData((prev) => ({ ...prev, ...docsRes.data }));
//       setDocFiles({});

//       setOrderStatus(orderRes.data);

//       setPaymentData({
//         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
//         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
//         agreed_amount: paymentRes.data.agreed_amount || '',
//         no_of_installment:
//           parseInt(paymentRes.data.no_of_installment, 10) || 0,
//         agree_remarks: paymentRes.data.agree_remarks || '',
//       });
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error || 'Failed to load data.'
//       );
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchAllData();
//     }
//   }, [open, excessId]);

//   const showError = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity('error');
//     setSnackbarOpen(true);
//   };

//   const handleChange = (e, section = 'docs') => {
//     const { name, value, checked, type } = e.target;

//     // Mobile validation
//     if (name === 'updated_mobile_number') {
//       if (!/^\d{0,10}$/.test(value)) return;
//     }

//     // =========================
//     // DOCS
//     // =========================
//     if (section === 'docs') {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }

//     // =========================
//     // ORDER STATUS
//     // =========================
//     else if (section === 'order') {
//       // Freezing Order and Summons are now dropdowns (waiting / Delivered /
//       // Returned to office) instead of checkboxes. The plain "issued"
//       // booleans are derived automatically — true once the value moves off
//       // "waiting" — same rule the backend applies.
//       if (name === 'is_freezing_order_delivered') {
//         if (value === 'waiting' && orderStatus.is_bank_freezed) {
//           showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_freezing_order_delivered: value,
//           is_freezing_order_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       if (name === 'is_summons_delivered') {
//         if (value === 'waiting' && orderStatus.is_partial_un_freezing_order_submited) {
//           showError('Please undo "Partial Unfreeze Order Submitted" before resetting Summons to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_summons_delivered: value,
//           is_summons_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       // REVERSE VALIDATIONS (remaining checkbox fields)

//       // Cannot uncheck bank freezed if summons issued
//       if (
//         name === 'is_bank_freezed' &&
//         !checked &&
//         orderStatus.is_summons_issued
//       ) {
//         showError(
//           'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
//         );
//         return;
//       }

//       // Cannot uncheck partial unfreeze submitted if partially unfreezed
//       if (
//         name === 'is_partial_un_freezing_order_submited' &&
//         !checked &&
//         orderStatus.is_partial_un_freezed
//       ) {
//         showError(
//           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
//         );
//         return;
//       }

//       // Cannot uncheck partially unfreezed if defreezing submitted
//       if (
//         name === 'is_partial_un_freezed' &&
//         !checked &&
//         orderStatus.is_defreezing_order_submited
//       ) {
//         showError(
//           'Please uncheck "Defreezing Order Submitted" before unchecking "Partially Unfreezed".'
//         );
//         return;
//       }

//       // Cannot uncheck defreezing submitted if bank defreezed
//       if (
//         name === 'is_defreezing_order_submited' &&
//         !checked &&
//         orderStatus.is_bank_defreezed
//       ) {
//         showError(
//           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
//         );
//         return;
//       }

//       setOrderStatus((prev) => ({
//         ...prev,
//         [name]: checked,
//       }));
//     }

//     // =========================
//     // PAYMENT
//     // =========================
//     else if (section === 'payment') {
//       if (name === 'no_of_installment') {
//         setPendingInstallmentValue(value);
//         setShowInstallmentWarning(true);
//         return;
//       }

//       // Mutual exclusivity
//       if (name === 'is_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_agreed_to_pay: true,
//           is_not_agreed_to_pay: false,
//         }));
//         return;
//       }

//       if (name === 'is_not_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_not_agreed_to_pay: true,
//           is_agreed_to_pay: false,
//           agreed_amount: '',
//           no_of_installment: 0,
//         }));
//         return;
//       }

//       setPaymentData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }
//   };

//   // ── Document file upload ────────────────────────────────────────────────
//   const handleDocFileChange = (fileFieldName) => (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (file.size > MAX_DOC_FILE_SIZE) {
//       showError(`${DOC_FILE_MAP[fileFieldName].label} file must be under 5 MB.`);
//       return;
//     }

//     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

//     // Uploading a file always marks that document as submitted, matching
//     // the backend behaviour — reflect it immediately in the checkbox.
//     const { boolField } = DOC_FILE_MAP[fileFieldName];
//     setFormData((prev) => ({ ...prev, [boolField]: true }));
//   };

//   const confirmInstallmentChange = () => {
//     setPaymentData((prev) => ({
//       ...prev,
//       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
//     }));

//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const cancelInstallmentChange = () => {
//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const buildDocsFormData = () => {
//     const fd = new FormData();
//     fd.append('current_address', formData.current_address || '');
//     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
//     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
//     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
//     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
//     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
//     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

//     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
//       const file = docFiles[fileFieldName];
//       if (file) fd.append(fileFieldName, file);
//     });

//     return fd;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!excessId) return;

//     // Validation: Agreed Amount should not exceed Excess Amount
//     if (paymentData.is_agreed_to_pay) {
//       const agreed = parseFloat(paymentData.agreed_amount || 0);
//       const maxAllowed = parseFloat(excessAmt || 0);

//       if (!Number.isFinite(agreed) || agreed < 0) {
//         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       if (agreed > maxAllowed) {
//         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }
//     }

//     if (
//       formData.updated_mobile_number &&
//       formData.updated_mobile_number.length !== 10
//     ) {
//       setSnackbarMessage('Mobile number must be exactly 10 digits');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       return;
//     }

//     let payloadPayment = { ...paymentData };

//     if (!paymentData.is_agreed_to_pay) {
//       payloadPayment = {
//         is_agreed_to_pay: false,
//         is_not_agreed_to_pay: true,
//         agreed_amount: null,
//         no_of_installment: 0,
//         agree_remarks: paymentData.agree_remarks || '',
//       };
//     }

//     setLoading(true);

//     try {
//       await Promise.all([
//         api.patch(
//           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
//           buildDocsFormData(),
//           { headers: { 'Content-Type': 'multipart/form-data' } }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
//           orderStatus
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
//           payloadPayment
//         ),
//       ]);

//       await fetchAllData();

//       setSnackbarMessage('Updated Successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);

//       setTimeout(() => onClose(), 1000);
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error ||
//           err.response?.data?.message ||
//           'Failed to update.'
//       );

//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const docsDisabled = !orderStatus.is_summons_issued;

//   // Small reusable row: checkbox + upload button + view link
//   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
//     const { boolField, linkField } = DOC_FILE_MAP[fileFieldName];
//     const stagedFile = docFiles[fileFieldName];
//     const existingLink = formData[linkField];

//     return (
//       <Box
//         display="flex"
//         alignItems="center"
//         flexWrap="wrap"
//         gap={1}
//         sx={{ py: 0.5 }}
//       >
//         <FormControlLabel
//           sx={{ minWidth: 200 }}
//           control={
//             <Checkbox
//               checked={formData[boolField]}
//               name={boolField}
//               onChange={(e) => handleChange(e, 'docs')}
//               disabled={docsDisabled}
//             />
//           }
//           label={checkboxLabel}
//         />

//         <Tooltip title={docsDisabled ? 'Enable Summons Issued first' : 'Upload file (max 5 MB)'}>
//           <span>
//             <Button
//               size="small"
//               variant="outlined"
//               component="label"
//               startIcon={<UploadFileIcon fontSize="small" />}
//               disabled={docsDisabled}
//             >
//               {stagedFile ? stagedFile.name : 'Upload'}
//               <input
//                 type="file"
//                 hidden
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={handleDocFileChange(fileFieldName)}
//               />
//             </Button>
//           </span>
//         </Tooltip>

//         {existingLink && (
//           <Tooltip title="View uploaded file">
//             <IconButton
//               size="small"
//               component={Link}
//               href={existingLink}
//               target="_blank"
//               rel="noopener"
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//        >
//         <DialogTitle>
//           Edit Document & Order Status
//         </DialogTitle>

//         <DialogContent>
//           <Box component="form" onSubmit={handleSubmit} p={2}>
//             {/* REFERENCE ID */}
//             <Typography variant="subtitle2" gutterBottom>
//               Reference ID:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#1976d2',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 {refId}
//               </Box>
//             </Typography>

//             {/* EXCESS AMOUNT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Excess Amount:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#2e7d32',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 ₹ {excessAmt || 0}
//               </Box>
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#8B0000',
//                 fontWeight: 600,
//                 mb: 2,
//               }}
//             >
//               Please add Reference Id on Hard copy
//             </Typography>

//             {/* ORDER STATUS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Order Status
//             </Typography>

//             <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
//               <FormControl size="small" sx={{ minWidth: 220 }}>
//                 <InputLabel>Freezing Order</InputLabel>
//                 <Select
//                   label="Freezing Order"
//                   name="is_freezing_order_delivered"
//                   value={orderStatus.is_freezing_order_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={!orderStatus.is_bank_freezed}>
//                 <InputLabel>Summons</InputLabel>
//                 <Select
//                   label="Summons"
//                   name="is_summons_delivered"
//                   value={orderStatus.is_summons_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={orderStatus.is_bank_freezed}
//                   name="is_bank_freezed"
//                   disabled={
//                     !orderStatus.is_freezing_order_issued
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                 />
//               }
//               label="Bank Freezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* PAYMENT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Payment Agreement
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={paymentData.is_agreed_to_pay}
//                   name="is_agreed_to_pay"
//                   disabled={!orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Agreed to Pay"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     paymentData.is_not_agreed_to_pay
//                   }
//                   name="is_not_agreed_to_pay"
//                   disabled={!orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Not Agreed to Pay"
//             />

//             {paymentData.is_agreed_to_pay &&
//             !paymentData.is_not_agreed_to_pay ? (
//               <>
//                 <TextField
//                   label="Agreed Amount"
//                   type="number"
//                   name="agreed_amount"
//                   value={paymentData.agreed_amount}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   sx={{ mt: 2 }}
//                 />

//                 <TextField
//                   label="No of Installments"
//                   type="number"
//                   name="no_of_installment"
//                   value={
//                     paymentData.no_of_installment
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   sx={{ mt: 2 }}
//                 />
//               </>
//             ) : null}

//             <TextField
//               label="Additional Remarks"
//               name="agree_remarks"
//               value={paymentData.agree_remarks}
//               onChange={(e) =>
//                 handleChange(e, 'payment')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               sx={{ mt: 2 }}
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* DOCS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Proof of Submission
//             </Typography>
//             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
//               Uploading a file automatically marks that document as submitted.
//               PDF/JPG/PNG, max 5 MB each.
//             </Typography>

//             <Box display="flex" flexDirection="column" mb={2}>
//               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
//               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
//               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

//               <Box sx={{ pl: 0.5, py: 0.5 }}>
//                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
//                 <Typography variant="body2" sx={{ pl: 4 }}>
//                   Download Affidavit Template:{' '}
//                   <Link
//                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                     target="_blank"
//                   >
//                     Click here
//                   </Link>
//                 </Typography>
//               </Box>

//               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
//             </Box>

//             <TextField
//               label="Current Address"
//               name="current_address"
//               value={formData.current_address}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               sx={{ mb: 2 }}
//             />

//             <TextField
//               label="Updated Mobile Number"
//               name="updated_mobile_number"
//               value={formData.updated_mobile_number}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               size="small"
//               inputProps={{ maxLength: 10 }}
//               helperText="Enter 10 digit mobile number"
//             />

//             <Divider sx={{ my: 3 }} />

//             {/* PARTIAL UNFREEZE */}
//             <Typography variant="subtitle2" gutterBottom>
//               Partial Unfreeze
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_partial_un_freezing_order_submited
//                   }
//                   name="is_partial_un_freezing_order_submited"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_summons_issued
//                   }
//                 />
//               }
//               label="Partial Unfreeze Order Submitted"
//             />

//             <Typography variant="body2">
//               Template:{' '}
//               <Link
//                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                 target="_blank"
//               >
//                 Click here
//               </Link>
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_partial_un_freezed
//                   }
//                   name="is_partial_un_freezed"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_partial_un_freezing_order_submited
//                   }
//                 />
//               }
//               label="Partially Unfreezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* FINAL DEFREEZE */}
//             <Typography variant="subtitle2" gutterBottom>
//               Final Defreeze
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_defreezing_order_submited
//                   }
//                   name="is_defreezing_order_submited"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_partial_un_freezed
//                   }
//                 />
//               }
//               label="Defreezing Order Submitted"
//             />

//             <Typography variant="body2">
//               Template:{' '}
//               <Link
//                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                 target="_blank"
//               >
//                 Click here
//               </Link>
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_bank_defreezed
//                   }
//                   name="is_bank_defreezed"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_defreezing_order_submited
//                   }
//                 />
//               }
//               label="Bank Defreezed"
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={onClose}
//             disabled={loading}
//           >
//             Cancel
//           </Button>

//           <Button
//             type="submit"
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={loading}
//           >
//             {loading ? 'Saving...' : 'Save'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* INSTALLMENT WARNING */}
//       <Dialog open={showInstallmentWarning}>
//         <DialogTitle>Warning</DialogTitle>

//         <DialogContent>
//           <Typography color="error">
//             Changing number of installments will
//             erase all existing installment data.
//             This action cannot be undone.
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={cancelInstallmentChange}>
//             Cancel
//           </Button>

//           <Button
//             onClick={confirmInstallmentChange}
//             color="error"
//             variant="contained"
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </>
//   );
// };

// export default DocsEditModal;


// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   Stack,
//   Chip,
// } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import PaymentsIcon from '@mui/icons-material/Payments';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

// import DocsEditModal from './staffDocsEpmsModal';
// import InstallmentEditModal from './staffInstallmentEditModal';
// import ClosureStatusModal from './closureStatusModule';

// // readOnly: true once the case has reached the `closed` stage — every
// // nested modal (documents, installments, closure) opens in view-only mode
// // instead of being hidden entirely, so the full history stays inspectable.
// const ExcessManageModal = ({ open, onClose, excessId, refId, excessAmt, readOnly = false }) => {
//   const [docsModalOpen, setDocsModalOpen] = useState(false);
//   const [installmentModalOpen, setInstallmentModalOpen] = useState(false);
//   const [closureModalOpen, setClosureModalOpen] = useState(false);

//   const handleClose = (event, reason) => {
//     if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
//     onClose();
//   };

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//   };

//   const ActionRow = ({ icon, label, onClick, sublabel }) => (
//     <Box
//       mt={2}
//       p={2}
//       borderRadius={2}
//       sx={{
//         background: '#fff',
//         boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//       }}
//     >
//       <Box>
//         <Typography fontWeight={500}>{label}</Typography>
//         {sublabel && (
//           <Typography variant="caption" color="text.secondary">{sublabel}</Typography>
//         )}
//       </Box>
//       <IconButton color="primary" onClick={onClick}>
//         {icon}
//       </IconButton>
//     </Box>
//   );

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//         PaperProps={{
//           sx: {
//             minHeight: '450px',
//             borderRadius: 3,
//             background: 'linear-gradient(135deg, #f8fafc, #eef2ff)',
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
//           Manage Excess Record
//           {readOnly && (
//             <Chip
//               icon={<LockOutlinedIcon fontSize="small" />}
//               label="Closed — View Only"
//               size="small"
//               color="default"
//               sx={{ fontWeight: 600 }}
//             />
//           )}
//         </DialogTitle>

//         <DialogContent>
//           <Box p={2}>
//             {/* ID Cards */}
//             <Stack direction="row" spacing={2} flexWrap="wrap">
//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 220,
//                   p: 2,
//                   borderRadius: 3,
//                   background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
//                   color: '#fff',
//                   boxShadow: '0 10px 25px rgba(99,102,241,0.3)',
//                   position: 'relative',
//                 }}
//               >
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Excess ID
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                   {excessId}
//                 </Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() => copyToClipboard(excessId)}
//                   sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Box>

//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 220,
//                   p: 2,
//                   borderRadius: 3,
//                   background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
//                   color: '#fff',
//                   boxShadow: '0 10px 25px rgba(59,130,246,0.3)',
//                   position: 'relative',
//                 }}
//               >
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Reference ID
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                   {refId}
//                 </Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() => copyToClipboard(refId)}
//                   sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Stack>

//             {/* Info Text */}
//             <Typography mt={3} color="text.secondary" sx={{ fontSize: '0.95rem' }}>
//               {readOnly
//                 ? 'This case is closed. Everything below is view-only for reference.'
//                 : 'Manage documents, installments, and closure status for this excess payment record.'}
//             </Typography>

//             {/* Manage Documents */}
//             <ActionRow
//               icon={readOnly ? <VisibilityIcon /> : <EditIcon />}
//               label="Documents & Order Status"
//               sublabel="Freezing/Summons status, Bank Freezed, the 5 documents, Payment Agreement"
//               onClick={() => setDocsModalOpen(true)}
//             />

//             {/* Manage Installments — made explicit and hard to miss */}
//             <ActionRow
//               icon={readOnly ? <VisibilityIcon /> : <PaymentsIcon />}
//               label="Installments"
//               sublabel="Track/mark each installment as paid, add payment reference details"
//               onClick={() => setInstallmentModalOpen(true)}
//             />

//             {/* Manage Closure — Partial Unfreeze / Final Defreeze, moved out of Documents */}
//             <ActionRow
//               icon={readOnly ? <VisibilityIcon /> : <EditIcon />}
//               label="Closure — Partial Unfreeze & Final Defreeze"
//               sublabel="Upload unfreeze/defreeze orders — marking Bank Defreezed closes the case"
//               onClick={() => setClosureModalOpen(true)}
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button
//             onClick={onClose}
//             variant="contained"
//             sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Nested Modals */}
//       <DocsEditModal
//         open={docsModalOpen}
//         onClose={() => setDocsModalOpen(false)}
//         excessId={excessId}
//         refId={refId}
//         excessAmt={excessAmt}
//         readOnly={readOnly}
//       />

//       <InstallmentEditModal
//         open={installmentModalOpen}
//         onClose={() => setInstallmentModalOpen(false)}
//         excessId={excessId}
//         readOnly={readOnly}
//       />

//       <ClosureStatusModal
//         open={closureModalOpen}
//         onClose={() => setClosureModalOpen(false)}
//         excessId={excessId}
//         refId={refId}
//         readOnly={readOnly}
//       />
//     </>
//   );
// };

// export default ExcessManageModal;


import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Stack,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PaymentsIcon from '@mui/icons-material/Payments';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import DocsEditModal from './staffDocsEpmsModal';
import InstallmentEditModal from './staffInstallmentEditModal';
import ClosureStatusModal from './closureStatusModule';

// readOnly: true once the case has reached the `closed` stage — every
// nested modal (documents, installments, closure) opens in view-only mode
// instead of being hidden entirely, so the full history stays inspectable.
const ExcessManageModal = ({ open, onClose, excessId, refId, excessAmt, readOnly = false, installmentsOnly = false }) => {
  const [docsModalOpen, setDocsModalOpen] = useState(false);
  const [installmentModalOpen, setInstallmentModalOpen] = useState(false);
  const [closureModalOpen, setClosureModalOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose();
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const ActionRow = ({ icon, label, onClick, sublabel }) => (
    <Box
      mt={2}
      p={2}
      borderRadius={2}
      sx={{
        background: '#fff',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography fontWeight={500}>{label}</Typography>
        {sublabel && (
          <Typography variant="caption" color="text.secondary">{sublabel}</Typography>
        )}
      </Box>
      <IconButton color="primary" onClick={onClick}>
        {icon}
      </IconButton>
    </Box>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            minHeight: '450px',
            borderRadius: 3,
            background: 'linear-gradient(135deg, #f8fafc, #eef2ff)',
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
          Manage Excess Record
          {readOnly && (
            <Chip
              icon={<LockOutlinedIcon fontSize="small" />}
              label="Closed — View Only"
              size="small"
              color="default"
              sx={{ fontWeight: 600 }}
            />
          )}
        </DialogTitle>

        <DialogContent>
          <Box p={2}>
            {/* ID Cards */}
            <Stack direction="row" spacing={2} flexWrap="wrap">
              <Box
                sx={{
                  flex: 1,
                  minWidth: 220,
                  p: 2,
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                  color: '#fff',
                  boxShadow: '0 10px 25px rgba(99,102,241,0.3)',
                  position: 'relative',
                }}
              >
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                  Excess ID
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {excessId}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => copyToClipboard(excessId)}
                  sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  minWidth: 220,
                  p: 2,
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
                  color: '#fff',
                  boxShadow: '0 10px 25px rgba(59,130,246,0.3)',
                  position: 'relative',
                }}
              >
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                  Reference ID
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {refId}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => copyToClipboard(refId)}
                  sx={{ position: 'absolute', top: 8, right: 8, color: '#fff' }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>
            </Stack>

            {/* Info Text */}
            <Typography mt={3} color="text.secondary" sx={{ fontSize: '0.95rem' }}>
              {readOnly
                ? 'This case is closed. Everything below is view-only for reference.'
                : installmentsOnly
                  ? 'This is a full lump-sum (Workflow 1) case still moving through approval. Since the payer has agreed to pay in full, you can record that payment now — no need to wait for approval to finish.'
                  : 'Manage documents, installments, and closure status for this excess payment record.'}
            </Typography>

            {/* Manage Documents — hidden during early WF1 collection: the
                agreed docs/order/payment data is already under review by
                Shirastedar/Tahsildar/AC/CA/SPLOCA and shouldn't change
                mid-approval. */}
            {!installmentsOnly && (
              <ActionRow
                icon={readOnly ? <VisibilityIcon /> : <EditIcon />}
                label="Documents & Order Status"
                sublabel="Freezing/Summons status, Bank Freezed, the 5 documents, Payment Agreement"
                onClick={() => setDocsModalOpen(true)}
              />
            )}

            {/* Manage Installments — made explicit and hard to miss */}
            <ActionRow
              icon={readOnly ? <VisibilityIcon /> : <PaymentsIcon />}
              label="Installments"
              sublabel={installmentsOnly
                ? 'Record the lump-sum payment as soon as it comes in'
                : 'Track/mark each installment as paid, add payment reference details'}
              onClick={() => setInstallmentModalOpen(true)}
            />

            {/* Manage Closure — Partial Unfreeze / Final Defreeze, moved out
                of Documents. Not relevant yet while approval is still in
                progress, so hidden during early WF1 collection too. */}
            {!installmentsOnly && (
              <ActionRow
                icon={readOnly ? <VisibilityIcon /> : <EditIcon />}
                label="Closure — Partial Unfreeze & Final Defreeze"
                sublabel="Upload unfreeze/defreeze orders — marking Bank Defreezed closes the case"
                onClick={() => setClosureModalOpen(true)}
              />
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Nested Modals */}
      <DocsEditModal
        open={docsModalOpen}
        onClose={() => setDocsModalOpen(false)}
        excessId={excessId}
        refId={refId}
        excessAmt={excessAmt}
        readOnly={readOnly}
      />

      <InstallmentEditModal
        open={installmentModalOpen}
        onClose={() => setInstallmentModalOpen(false)}
        excessId={excessId}
        readOnly={readOnly}
      />

      <ClosureStatusModal
        open={closureModalOpen}
        onClose={() => setClosureModalOpen(false)}
        excessId={excessId}
        refId={refId}
        readOnly={readOnly}
      />
    </>
  );
};

export default ExcessManageModal;